import { createElement, Component } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import cn from 'classnames';
import { withStore } from 'justorm/react';
import { Icon } from '../Icon/Icon.js';
import { Button } from '../Button/Button.js';
import { Scroll } from '../Scroll/Scroll.js';
import STORE from './store.js';
import S from './Notifications.styl.js';

function getTouchPos(e) {
    const { clientX: x, clientY: y } = e.targetTouches[0];
    return { x, y };
}
function getDeltaPos(p1, p2) {
    return {
        x: Math.abs(p2.x - p1.x),
        y: Math.abs(p2.y - p1.y),
    };
}
const TOUCH_MOVE_TRESHOLD = 50;
class Item extends Component {
    startPos = null;
    onTouchStart = e => {
        this.startPos = getTouchPos(e);
    };
    onTouchMove = e => {
        const { unpause } = this.props;
        if (!this.startPos)
            return;
        // e.preventDefault();
        e.stopPropagation();
        const pos = getTouchPos(e);
        const delta = getDeltaPos(this.startPos, pos);
        if (delta.x > delta.y && delta.x > TOUCH_MOVE_TRESHOLD) {
            unpause();
            this.closeMe();
        }
    };
    onTouchEnd = () => {
        const { unpause } = this.props;
        unpause();
        this.startPos = null;
    };
    onTouchCancel = () => (this.startPos = null);
    closeMe = () => {
        const { id, close } = this.props;
        close(id);
    };
    render() {
        const { type = 'default', title, content, visible, pause, unpause, } = this.props;
        const classes = cn(S.item, S[`type-${type}`], visible && S.visible);
        return (jsx("div", { className: classes, onMouseOver: pause, onFocus: pause, onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onMouseOut: unpause, onBlur: unpause, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchCancel, children: jsxs("div", { className: S.itemInner, children: [(title || content) && (jsxs("div", { className: S.text, children: [title && jsx("div", { className: S.title, children: title }), content && jsx("div", { className: S.content, children: content })] })), jsx(Button, { className: S.close, variant: "clear", square: true, onClick: this.closeMe, children: jsx(Icon, { type: "close", size: "s" }) })] }) }));
    }
}
const NotificationsStore = STORE;
const Notifications = withStore({
    notifications: ['items', 'data'],
})(function Notifications({ store, ...rest }) {
    const { notifications } = store;
    const { items, data, pause, unpause, close } = notifications;
    const api = { pause, unpause, close };
    const classes = cn(S.root, items.length === 0 && S.empty);
    return (jsx(Scroll, { ...rest, y: true, size: "s", className: classes, innerClassName: S.inner, offset: { y: { before: 22, after: 22 } }, children: items.map(id => (createElement(Item, { ...data[id], ...api, id: id, key: id }))) }));
});

export { Notifications, NotificationsStore };
